<template>
    <div class="img">
      <img src="/static/img/firm_intro/firm-intro-banner.png"/>
    </div>
</template>

<script>
  export default{
    name: 'homeFirmBanner'
  }
</script>

<style scoped>

  div.img {
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    display: flex;
  }

  div.container {
    padding: 0;
    margin: auto;
    width: auto;
  }

  p {
    font-family: Helvetica-Bold, "Helvetica Bold", Helvetica;
    font-weight: 700;
    font-style: normal;
    font-size: 36px;
    color: rgb(255, 255, 255);
    text-align: left;
    white-space: pre-line;
    line-height: 48px;
    padding: 0;
    margin: 0;
  }

  img {
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// HomeFirmBanner.vue?c16970f6